import styles from "./charCount.module.scss";

/**
 * `{used}/{max}` character-count indicator for length-limited inputs. Renders
 * nothing when `max` is undefined/null (limit not known yet). Turns warning near
 * the cap and error if somehow over it (e.g. pre-filled value longer than a
 * tightened limit). Place directly under the input it describes.
 */
export function CharCount({ value, max }: { value: string | null | undefined; max?: number | null }) {
  // A real varchar/nvarchar cap is ≤ 8000/4000. -1 (MAX) and the huge values
  // text/ntext report (2147483647 / 1073741823) mean "effectively unlimited" —
  // show no indicator.
  if (max == null || max <= 0 || max > 8000) return null;
  const len = (value ?? "").length;
  const cls = len > max ? styles.over : len >= max * 0.9 ? styles.near : styles.ok;
  return <span className={`${styles.count} ${cls}`}>{len}/{max}</span>;
}
